import { LegalLayout, LegalSection } from "./LegalLayout"

/**
 * DRAFT — pendente de revisão jurídica (CL-01).
 * Conteúdo canônico em pt-br. Cobre os 5 pontos exigidos pelo Google OAuth
 * consent screen. Section headings: i18n keys (CL-04). Body prose remains
 * pt-br until legal review.
 */
export const PrivacyPolicyPage = () => {
  return (
    <LegalLayout titleKey="legal.privacy.title" lastUpdated="2026-05-19">
      <LegalSection headingKey="legal.privacy.sections.informationCollected">
        <p>
          Coletamos dados de conta (nome, e-mail), conteúdo que você envia
          (áudios de sessão, transcrições, notas e conteúdo de campanha), dados
          de uso e logs técnicos, e dados de pagamento processados pelo Stripe
          (não armazenamos números completos de cartão).
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.howWeUse">
        <p>
          Usamos os dados para fornecer e operar o serviço (transcrição,
          extração e organização por IA, busca), processar pagamentos e
          créditos, comunicar mudanças, e melhorar o produto. Não vendemos seus
          dados.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.sharingSubprocessors">
        <p>
          Compartilhamos dados apenas com subprocessadores necessários à
          operação do serviço:
        </p>
        <ul className="list-disc space-y-1 pl-5">
          <li>
            <strong>Supabase</strong> — banco de dados e autenticação.
          </li>
          <li>
            <strong>Cloudflare</strong> — hospedagem, armazenamento de arquivos
            e processamento.
          </li>
          <li>
            <strong>Stripe</strong> — processamento de pagamentos.
          </li>
          <li>
            <strong>Provedores de IA</strong> — transcrição e geração de
            conteúdo a partir do material da sessão.
          </li>
        </ul>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.disclosure">
        <p>
          A divulgação a terceiros ocorre exclusivamente via integrações
          técnicas com os subprocessadores acima, sob contrato, e quando exigido
          por lei ou ordem judicial. Não há divulgação para fins de publicidade
          de terceiros.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.security">
        <p>
          Adotamos criptografia em trânsito (TLS), controle de acesso por
          autenticação e isolamento por usuário (RLS no banco), e princípio do
          menor privilégio nos serviços internos. Nenhum sistema é 100% seguro;
          em caso de incidente relevante, notificaremos os titulares afetados
          conforme a lei aplicável.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.yourRights">
        <p>
          Você pode solicitar acesso, correção, portabilidade ou exclusão dos
          seus dados, e revogar consentimento. O fluxo de exclusão de dados está
          em implementação (CL-05). Contato do controlador:{" "}
          <strong>[a definir — placeholder de revisão jurídica]</strong>.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.retention">
        <p>
          Mantemos os dados enquanto a conta estiver ativa e pelo período
          necessário para cumprir obrigações legais. Após a exclusão da conta,
          os dados são removidos ou anonimizados em prazo razoável.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.privacy.sections.policyChanges">
        <p>
          Podemos atualizar esta política. Mudanças materiais serão comunicadas
          pelos canais do produto, e a data de "última atualização" no topo será
          revista.
        </p>
      </LegalSection>
    </LegalLayout>
  )
}
